import type { WidgetProps } from "@rjsf/utils";
import cx from "clsx";
import React from "react";
import { Tooltip } from "../../Tooltip";
import * as styles from "./Label.module.scss";
interface LabelProps {
	id: string;
	label: string;
	required?: boolean;
	tooltip?: string;
}

const Label: React.FC<LabelProps> = ({ id, label, required, tooltip }) => {
	return (
		<div className={cx(styles.labelWrapper)}>
			<label htmlFor={id}>
				{label}

				{required && (
					<span aria-hidden="true" className={styles.required}>
						*
					</span>
				)}
			</label>

			{tooltip && <Tooltip id={id} text={tooltip as string} />}
		</div>
	);
};

type LabelWidgetProps = WidgetProps<LabelProps>;
export const LabelWidget: React.FC<LabelWidgetProps> = ({
	id,
	label,
	required,
	tooltip,
}) => {
	return <Label id={id} label={label} required={required} tooltip={tooltip} />;
};

export default Label;
